/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
import {getCaptcha, getUserByToken, login} from '../core/_requests'
import {KTSVG} from '../../../../_metronic/helpers'
import {useAuth} from '../core/Auth'

const loginSchema = Yup.object().shape({
    phone: Yup.string()
        .min(3, 'حداقل 3 کاراکتر مورد تایید میباشد')
        .max(50, 'حداکثر 50 کاراکتر مورد تایید میباشد')
        .required('اجباری میباشد'),
    password: Yup.string()
        .min(3, 'حداقل 3 کاراکتر مورد تایید میباشد')
        .max(50, 'حداکثر 50 کاراکتر مورد تایید میباشد')
        .required('اجباری میباشد'),
    captcha: Yup.string()
        .min(4, 'تصویر امنیتی را به درسی وارد نمایید')
        .max(4, 'تصویر امنیتی را به درسی وارد نمایید')
        .required('تصویر امنیتی اجباری میباشد')
})

const initialValues = {
    phone: '',
    password: '',
    captcha: ''
}

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function Login() {
    const [loading, setLoading] = useState(false)
    const [captcha, setCaptcha] = useState("");
    const {saveAuth, setCurrentUser} = useAuth()
    const formik = useFormik({
        initialValues,
        validationSchema: loginSchema,
        onSubmit: async (values, {setStatus, setSubmitting}) => {
            setLoading(true)
            try {
                const {data: auth} = await login(values.phone, values.password, values.captcha)
                saveAuth(auth)
                const {data: user} = await getUserByToken(auth.access_token)
                setCurrentUser(user)
            } catch (error) {
                console.error(error)
                saveAuth(undefined)
                setStatus('اطلاعات وارد شده معبتر نمیباشد')
                setSubmitting(false)
                setLoading(false)
            }
        },
    })

    async function refreshCaptcha() {
        try {
            const {data: captchaData} = await getCaptcha();
            setCaptcha(captchaData);
        } catch {

        }
    }

    useEffect(() => {
            refreshCaptcha()
        },
        [])
    return (
        <form
            className='form w-100'
            onSubmit={formik.handleSubmit}
            noValidate
            id='kt_login_signin_form'
        >
            {/* begin::Heading */}
            <div className='text-center mb-10'>
                <h1 className='text-dark mb-3'>ورود به پرتال اپ تامین</h1>
                <div className='text-gray-400 fw-semibold fs-4'>
                    آیا کاربری جدید هستید ؟ {' '}
                    <a href="https://apptamin.ir/register" className='link-primary fw-bold'>ساخت  کاربری جدید</a>
                    {/*<Link to='/auth/registration' >*/}
                    {/*    ساخت  کاربری جدید*/}
                    {/*</Link>*/}
                </div>
            </div>
            {/* begin::Heading */}

            {formik.status ? (
                <div className='mb-lg-15 alert alert-danger'>
                    <div className='alert-text font-weight-bold'>{formik.status}</div>
                </div>
            ) : (
                <div></div>
                // <div className='mb-10 bg-light-info p-8 rounded'>
                //     <div className='text-info'>
                //         Use account <strong>admin@demo.com</strong> and password <strong>demo</strong> to
                //         continue.
                //     </div>
                // </div>
            )}

            {/* begin::Form group */}
            <div className='fv-row mb-10'>
                <label className='form-label fs-6 fw-bold text-dark'>شماره تماس</label>
                <input
                    placeholder='شماره تماس '
                    {...formik.getFieldProps('phone')}
                    className={clsx(
                        'form-control form-control-lg form-control-solid',
                        {'is-invalid': formik.touched.phone && formik.errors.phone},
                        {
                            'is-valid': formik.touched.phone && !formik.errors.phone,
                        }
                    )}
                    type='text'
                    name='phone'
                    autoComplete='off'
                />
                {formik.touched.phone && formik.errors.phone && (
                    <div className='fv-plugins-message-container'>
                        <span role='alert'>{formik.errors.phone}</span>
                    </div>
                )}
            </div>
            {/* end::Form group */}

            {/* begin::Form group */}
            <div className='fv-row mb-10'>
                <div className='d-flex justify-content-between mt-n5'>
                    <div className='d-flex flex-stack mb-2'>
                        {/* begin::Label */}
                        <label className='form-label fw-bold text-dark fs-6 mb-0'> رمز عبور </label>
                        {/* end::Label */}
                        {/* begin::Link */}
                        <Link
                            to='/auth/forgot-password'
                            className='link-primary fs-6 fw-bold p-1'
                            style={{marginLeft: '5px'}}
                        >
                            <span> </span>
                            بازیابی رمز عبور
                        </Link>
                        {/* end::Link */}
                    </div>
                </div>
                <input
                    type='password'
                    autoComplete='off'
                    {...formik.getFieldProps('password')}
                    className={clsx(
                        'form-control form-control-lg form-control-solid',
                        {
                            'is-invalid': formik.touched.password && formik.errors.password,
                        },
                        {
                            'is-valid': formik.touched.password && !formik.errors.password,
                        }
                    )}
                />
                {formik.touched.password && formik.errors.password && (
                    <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                            <span role='alert'>{formik.errors.password}</span>
                        </div>
                    </div>
                )}
            </div>
            {/* end::Form group */}

            {/* begin::Form group */}
            <div className='fv-row mb-10 row'>
                <div className="col-6">
                    <label className='form-label fs-6 fw-bold text-dark'>تصویر امنیتی</label>

                    <input
                        placeholder='تصویر امنیتی '
                        {...formik.getFieldProps('captcha')}
                        className={clsx(
                            'form-control form-control-lg form-control-solid ',
                            {'is-invalid': formik.touched.captcha && formik.errors.captcha},
                            {
                                'is-valid': formik.touched.captcha && !formik.errors.captcha,
                            }
                        )}
                        type='text'
                        name='captcha'
                        autoComplete='off'
                    />
                    {formik.touched.phone && formik.errors.phone && (
                        <div className='fv-plugins-message-container'>
                            <span role='alert'>{formik.errors.captcha}</span>
                        </div>
                    )}
                </div>

                <div className="col-6 ">
                    <label className='form-label fs-6 fw-bold text-dark'>تصویر </label>
                    <div className="row">
                        <div className="col-8">
                            <img src={captcha} className="col-8"/>
                        </div>
                        <div className="col-4">
                            <button onClick={refreshCaptcha} className="btn btn-light-primary me-3">

                                <KTSVG path='/media/icons/duotune/arrows/arr029.svg' className='svg-icon-2'/>

                            </button>
                        </div>

                    </div>


                </div>

            </div>
            {/* end::Form group */}


            {/* begin::Action */}
            <div className='text-center'>
                <button
                    type='submit'
                    id='kt_sign_in_submit'
                    className='btn btn-lg btn-primary w-100 mb-5'
                    disabled={formik.isSubmitting || !formik.isValid}
                >
                    {!loading && <span className='indicator-label'>تایید </span>}
                    {loading && (
                        <span className='indicator-progress' style={{display: 'block'}}>
              لطفاً صبر کنید ...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
                    )}
                </button>

                {/*/!* begin::Separator *!/*/}
                {/*<div className='text-center text-muted text-uppercase fw-bold mb-5'>or</div>*/}
                {/*/!* end::Separator *!/*/}

                {/*/!* begin::Google link *!/*/}
                {/*<a href='#' className='btn btn-flex flex-center btn-light btn-lg w-100 mb-5'>*/}
                {/*  <img*/}
                {/*    alt='Logo'*/}
                {/*    src={toAbsoluteUrl('/media/svg/brand-logos/google-icon.svg')}*/}
                {/*    className='h-20px me-3'*/}
                {/*  />*/}
                {/*  Continue with Google*/}
                {/*</a>*/}
                {/*/!* end::Google link *!/*/}

                {/*/!* begin::Google link *!/*/}
                {/*<a href='#' className='btn btn-flex flex-center btn-light btn-lg w-100 mb-5'>*/}
                {/*  <img*/}
                {/*    alt='Logo'*/}
                {/*    src={toAbsoluteUrl('/media/svg/brand-logos/facebook-4.svg')}*/}
                {/*    className='h-20px me-3'*/}
                {/*  />*/}
                {/*  Continue with Facebook*/}
                {/*</a>*/}
                {/*/!* end::Google link *!/*/}

                {/*/!* begin::Google link *!/*/}
                {/*<a href='#' className='btn btn-flex flex-center btn-light btn-lg w-100'>*/}
                {/*  <img*/}
                {/*    alt='Logo'*/}
                {/*    src={toAbsoluteUrl('/media/svg/brand-logos/apple-black.svg')}*/}
                {/*    className='h-20px me-3'*/}
                {/*  />*/}
                {/*  Continue with Apple*/}
                {/*</a>*/}
                {/*/!* end::Google link *!/*/}
            </div>
            {/* end::Action */}
        </form>
    )
}
